import React, { useContext, useState } from "react";
import { List } from "@mui/material";
import { ReactComponent as DashboardIcon } from "../Images/dasimage.svg";
import { ReactComponent as PeopleIcon } from "../Images/peoples.svg";
import { ReactComponent as MedicalServicesIcon } from "../Images/stethoscope.svg";
import { ReactComponent as DescriptionIcon } from "../Images/discription.svg";
import { ReactComponent as PowerSettingsNewIcon } from "../Images/power.svg";
import { ReactComponent as DownloadIcon } from "../Images/download-icon.svg";
import Man from "../Images/man.svg";
import { NavLink, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { AuthContext } from "../../context/AuthContext";
import { apisPath, paths } from "../../utils/path";
import { canAccessPage } from "../../config/rolesConfig";
import { capitalizeWords } from "../../helpers/commonHelper";
import { CommonContext } from "../../context/CommonContext";
import { authHttp } from "../../services/commonHttpService";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout, userName, userRole } = useContext(AuthContext);
  const { setAlertState } = useContext(CommonContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    setIsOpen(false);
    // Show confirmation dialog before logout
    setAlertState({
      open: true,
      title: 'Are you sure you want to logout?',
      message: '',
      btnTxt: 'Yes',
      cancelBtnTxt: 'No',
      status: 'warning',
      type: 'confirm',
      onConfirm: async () => {
        // This will execute when user clicks "Yes"
        await authHttp.post(
          `${apisPath?.logOut}`
        );
        await logout();
        navigate(`${paths?.login}`);
      },
      onClose: () => {
        // This will execute when user clicks "No" - modal just closes
        console.log('Logout cancelled');
      }
    });
  };

  // All menu items
  const allMenuItems = [
    {
      key: "adminDashboard",
      path: `${paths?.user?.adminDashboard}`,
      title: "Dashboard",
      icon: <DashboardIcon />
    },
    {
      key: "stateDashboard",
      path: `${paths?.user?.stateDashboard}`,
      title: "Dashboard",
      icon: <DashboardIcon />
    },
    {
      key: "dashboard",
      path: `${paths?.user?.dashboard}`,
      title: "Dashboard",
      icon: <DashboardIcon />
    },
    {
      key: "moDashboard",
      path: `${paths?.user?.moDashboard}`,
      title: "Dashboard",
      icon: <DashboardIcon />
    },
    {
      key: "beneficiaryManagement",
      path: `${paths?.user?.beneficiaryManagement}`,
      title: "Beneficiary Management",
      icon: <PeopleIcon />
    },
    {
      key: "moBeneficiaryManagement",
      path: `${paths?.user?.moBeneficiaryManagement}`,
      title: "Beneficiary Management",
      icon: <PeopleIcon />
    },
    // { 
    //   key: "treatmentModule", 
    //   path: `${paths?.user?.treatmentModule}`, 
    //   title: "Treatment", 
    //   icon: <MedicalServicesIcon />
    // },
    // { 
    //   key: "treatmentProcedure", 
    //   path: `${paths?.user?.treatmentProcedure}`, 
    //   title: "Treatment", 
    //   icon: <MedicalServicesIcon />
    // },
    {
      key: "appointmentManagement",
      path: `${paths?.user?.appointmentManagement}`,
      title: "Appointments",
      icon: <DescriptionIcon />
    },
    {
      key: "adminDownloadData",
      path: `${paths?.user?.adminDownloadData}`,
      title: "Download Data",
      icon: <DownloadIcon />
    },
    {
      key: "stateCredDownload",
      path: `${paths?.user?.stateCredDownload}`,
      title: "Download Credentials",
      icon: <DownloadIcon />
    },
    // {
    //   key: "downloadData",
    //   path: `${paths?.user?.downloadData}`,
    //   title: "Download Data",
    //   icon: <DownloadIcon />
    // },
    // {
    //   key: "moDownloadData",
    //   path: `${paths?.user?.moDownloadData}`,
    //   title: "Download Data",
    //   icon: <DownloadIcon />
    // },
  ];

  // Filter based on role
  const menuItems = allMenuItems.filter(item => canAccessPage(userRole, item?.key));

  return (
    <>
      {/* Hamburger Button (only mobile) */}
      <div className="hamburger-icon" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </div>

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        {/* Logo */}
        <div className="mainLogoSideBar">
          <img src={Man} alt="logo" />
          <p>{capitalizeWords(userName)}</p>
          {/* <span>{userRole}</span> */}
        </div>

        {/* Menu */}
        <List className="menu">
          {menuItems.map((item) => (
            <NavLink
              to={item?.path}
              key={item?.key}
              end={item?.key === "dashboard" || item?.key === "moDashboard"}
              className={({ isActive }) =>
                isActive ? "menu-item active" : "menu-item"
              }
               onClick={() => setIsOpen(false)}   // 👈 ADD THIS
            >
              {/* Fixed Icon */}
              <div className="icon">{item?.icon}</div>

              {/* Tile (shows when active) */}
              <div className="tile">
                <div className="tile-icon">{item?.icon}</div>
                <span>{item?.title}</span>
              </div>
            </NavLink>
          ))}


          <div className="menu-item logout" onClick={handleLogout}>
            <div className="icon">
              <PowerSettingsNewIcon />
            </div>
            <div className="tile">
              <div className="tile-icon">
                <PowerSettingsNewIcon />
              </div>
              <span>Logout</span>
            </div>
          </div>
        </List>
      </div>
    </>
  );
};

export default Sidebar;
